export const arrayMonths = {
  "01": "gen",
  "02": "feb",
  "03": "mar",
  "04": "apr",
  "05": "mag",
  "06": "giu",
  "07": "lug",
  "08": "ago",
  "09": "set",
  10: "ott",
  11: "nov",
  12: "dic"
};
